<sh-list-row-title [title]="cell.title" [info]="cell.info" [navigationLink]="cell.navigationLink"></sh-list-row-title>
